import React, { useState, useEffect } from "react";
import { getUserData } from "../../../controllers/UsersController";
import { Badge, Paper, Box, Typography, Stack, Chip } from "@mui/material";
import { formatDate } from "../../../utils/Utils";

function CommentBox({ id, user_id, subject, date, tags, onClick, is_viewed: initialIsViewed }) {
    const [isViewed, setIsViewed] = useState(initialIsViewed);
    const [user, setUser] = useState(null);
    
    const handleClick = () => {
        onClick(id, user.username);
        setIsViewed(true);
    };

    useEffect(() => {
        getUserData(user_id)
            .then((data) => {
                setUser(data);
            })
            .catch((error) => {
                console.error("Error fetching user data:", error);
                setUser(null);
            });
    }, [user_id]);

    if (!user) {
        return null;
    }
    return (
        <Box margin="1rem">
            <Badge badgeContent="" invisible={isViewed} color="error">
                <Paper elevation={3} onClick={handleClick}
                    style={{
                        cursor: "pointer",
                        padding: "0.5rem",
                    }}>
                    <>
                    <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="baseline">
                        <Typography variant="h6" paddingRight="1rem">Commentaire de {user.username}</Typography>
                        <Typography variant="body1">{formatDate(date)}</Typography>
                    </Box>
                    <p>{subject}</p>
                    <Stack direction="row" spacing={1}>
                        {tags && tags.map((tag, index) => (
                            <Chip key={index} label={tag} />
                        ))}
                    </Stack>
                    </>
                </Paper>
            </Badge>
        </Box>
    );
}

export default CommentBox;